<template>
    <order-timeline-box
        class="h-100"
        :title="__('orders.states.' + OrderState.Delivered)"
        :message="logsByState.hasOwnProperty(OrderState.Delivered) ? users[logsByState[OrderState.Delivered].issuer_uid] : ''"
        :timestamp="logsByState.hasOwnProperty(OrderState.Delivered) ? logsByState[OrderState.Delivered].created_at : ''"
        :complete="isComplete"
        icon="fa-people-carry"
    >
        <button class="btn btn-success"
                :disabled="logsByState.hasOwnProperty(OrderState.Refunded)">
            <i class="fas fa-truck"/>
            {{ __('actions.order.transition_to.send') }}
        </button>
    </order-timeline-box>
</template>

<script>
import {OrderState} from '@composables/orderStates';
import AddShippingDetailsModal from "@components/Orders/Modals/AddShippingDetailsModal.vue";
import OrderTimelineBox from "@components/Orders/Timeline/OrderTimelineBox.vue";

export default {
    components: {AddShippingDetailsModal, OrderTimelineBox},

    props: {
        store: Object,
        order: Object,
        users: Object,
    },

    data() {
        return {
        };
    },

    computed: {
        OrderState() {
            return OrderState;
        },

        logsByState(){
            return this.order.logs_by_state;
        },

        isComplete() {
            return this.logsByState.hasOwnProperty(OrderState.Delivered)
        },
    },
};
</script>
